var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTokenRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_27418_115094)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.00037,
    cy: 6,
    r: 6,
    fill: "url(#paint0_linear_27418_115094)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_27418_115094)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.00017,
    cy: 6.00015,
    r: 4.61538,
    fill: "url(#paint1_linear_27418_115094)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_27418_115094)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_27418_115094)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_27418_115094",
    fill: "url(#paint2_linear_27418_115094)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "stroke1_27418_115094",
    maskUnits: "userSpaceOnUse",
    x: 5.73839,
    y: 2.18311,
    width: 4,
    height: 4,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 5.73839,
    y: 2.18311,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_27418_115094"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.29708 5.6158C9.01769 5.6158 8.99914 5.60557 8.95296 5.34416C8.78385 4.38683 8.00516 3.86603 7.14317 3.70293C7.08055 3.69109 7.01602 3.68568 6.9534 3.67625C6.71682 3.63993 6.73854 3.51776 6.73917 3.47964C6.74043 3.41585 6.74507 3.35005 6.76236 3.28805C6.79399 3.17491 6.90975 3.18053 6.96225 3.18494C8.12787 3.28204 8.98585 3.77134 9.45164 4.8344C9.51679 4.98326 9.54652 5.14816 9.57667 5.30825C9.62812 5.58109 9.59144 5.6162 9.29687 5.616L9.29708 5.6158Z",
    strokeWidth: 0.0659341,
    stroke: "url(#paint3_linear_27418_115094)",
    mask: "url(#stroke1_27418_115094)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_27418_115094)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke2_27418_115094",
    fill: "url(#paint4_linear_27418_115094)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "stroke3_27418_115094",
    maskUnits: "userSpaceOnUse",
    x: 5.722,
    y: 3.10059,
    width: 3,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 5.722,
    y: 3.10059,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke2_27418_115094"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.19059 5.61365C7.92976 5.61645 7.93883 5.61425 7.87389 5.37672C7.76635 4.98371 7.48022 4.7528 7.08296 4.63304C7.04564 4.6218 7.00621 4.61639 6.96783 4.60856C6.73779 4.56182 6.70342 4.51849 6.72935 4.30563C6.74517 4.17583 6.81285 4.10421 6.95961 4.101C7.52133 4.08857 7.93419 4.35418 8.24014 4.76384C8.37762 4.9478 8.45944 5.16728 8.51742 5.40501C8.54863 5.5336 8.48453 5.60422 8.33862 5.61304C8.28949 5.61605 8.23993 5.61344 8.19059 5.61344V5.61365Z",
    strokeWidth: 0.0659341,
    stroke: "url(#paint5_linear_27418_115094)",
    mask: "url(#stroke3_27418_115094)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_27418_115094)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke4_27418_115094",
    fill: "url(#paint6_linear_27418_115094)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "stroke5_27418_115094",
    maskUnits: "userSpaceOnUse",
    x: 1.70312,
    y: 3.69189,
    width: 6,
    height: 6,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.70312,
    y: 3.69189,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke4_27418_115094"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.55586 4.89512C7.21458 5.1186 7.56397 5.46246 7.59096 6.12469C7.61014 6.59554 7.60276 7.07099 7.55363 7.53943C7.51062 7.94989 7.23651 8.25402 6.83693 8.40067C6.52086 8.51683 6.17821 8.60009 5.84126 8.62597C5.19077 8.67552 4.53395 8.69538 3.89125 8.54251C3.29896 8.40148 2.86248 8.09092 2.76591 7.48246C2.68072 6.94521 2.6803 6.40274 2.77645 5.8653C2.85447 5.42835 3.13006 5.12061 3.55683 4.97075C3.85878 4.86483 4.4884 4.69169 5.02883 4.69189C5.68333 4.6921 6.14131 4.75449 6.55586 4.89512ZM5.99772 7.90375C6.33825 7.83173 6.48606 7.64435 6.49302 7.31133C6.50146 6.90609 6.50146 6.50024 6.49302 6.095C6.48606 5.75375 6.35491 5.58564 6.0051 5.49877C5.79529 5.44661 5.57242 5.41391 5.35671 5.41872C5.00331 5.42655 4.64444 5.443 4.29989 5.51041C3.97876 5.5732 3.84508 5.78043 3.84128 6.0944C3.83664 6.48881 3.83664 6.88322 3.84107 7.27763C3.84508 7.63874 3.99099 7.83012 4.35788 7.90676C4.62208 7.96193 5.72803 7.96092 5.99793 7.90375H5.99772Z",
    strokeWidth: 0.0659341,
    stroke: "url(#paint7_linear_27418_115094)",
    mask: "url(#stroke5_27418_115094)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_27418_115094",
    x: 0.000365257,
    y: -0.527473,
    width: 12,
    height: 13.0549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.527473
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.824176
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.691627 0 0 0 0 0.439322 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_27418_115094"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.527473
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.659341
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968368 0 0 0 0 0.929706 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_27418_115094",
    result: "effect2_innerShadow_27418_115094"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_27418_115094",
    x: 1.38478,
    y: 1.18696,
    width: 9.23077,
    height: 9.82436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.395604
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.527473
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.691275 0 0 0 0 0 0 0 0 0 0.264989 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_27418_115094"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.197802
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.263736
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.884935 0 0 0 0 0.0997812 0 0 0 0 0.0997812 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_27418_115094",
    result: "effect2_innerShadow_27418_115094"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_27418_115094",
    x: 6.29343,
    y: 2.82023,
    width: 3.73128,
    height: 3.29023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0659341
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.197802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.525879 0 0 0 0 0.256619 0 0 0 0 0.256619 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27418_115094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27418_115094",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.185814,
    dy: 0.185814
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0929072
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_27418_115094"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_27418_115094",
    x: 6.30974,
    y: 2.82023,
    width: 3.71498,
    height: 3.29023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0659341
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.197802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.525879 0 0 0 0 0.256619 0 0 0 0 0.256619 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27418_115094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27418_115094",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.185814,
    dy: 0.185814
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0929072
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_27418_115094"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_27418_115094",
    x: 6.29343,
    y: 3.73771,
    width: 2.66026,
    height: 2.37129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0659341
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.197802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.525879 0 0 0 0 0.256619 0 0 0 0 0.256619 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27418_115094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27418_115094",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.185814,
    dy: 0.185814
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0929072
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_27418_115094"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_27418_115094",
    x: 2.27455,
    y: 4.32902,
    width: 5.75475,
    height: 4.82734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.0659341
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.197802
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.525879 0 0 0 0 0.256619 0 0 0 0 0.256619 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27418_115094"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27418_115094",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.185814,
    dy: 0.185814
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0929072
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_27418_115094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27418_115094",
    x1: 5.99928,
    y1: 1.29975,
    x2: 5.99928,
    y2: 12.6648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF6F71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27418_115094",
    x1: 4.21995,
    y1: 0.626524,
    x2: 8.01115,
    y2: 11.4727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F20C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27418_115094",
    x1: 8.28288,
    y1: 3.42707,
    x2: 8.28185,
    y2: 5.77064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27418_115094",
    x1: 8.16727,
    y1: 3.18311,
    x2: 8.16727,
    y2: 5.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27418_115094",
    x1: 7.69652,
    y1: 4.2524,
    x2: 7.69589,
    y2: 5.71072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27418_115094",
    x1: 7.62357,
    y1: 4.10059,
    x2: 7.62357,
    y2: 5.61449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_27418_115094",
    x1: 5.35006,
    y1: 5.09002,
    x2: 5.34846,
    y2: 8.91445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_27418_115094",
    x1: 5.15193,
    y1: 4.69189,
    x2: 5.15193,
    y2: 8.66209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2BE"
  })), /*#__PURE__*/React.createElement("path", {
    id: "stroke0_27418_115094",
    d: "M9.29708 5.6158C9.01769 5.6158 8.99914 5.60557 8.95296 5.34416C8.78385 4.38683 8.00516 3.86603 7.14317 3.70293C7.08055 3.69109 7.01602 3.68568 6.9534 3.67625C6.71682 3.63993 6.73854 3.51776 6.73917 3.47964C6.74043 3.41585 6.74507 3.35005 6.76236 3.28805C6.79399 3.17491 6.90975 3.18053 6.96225 3.18494C8.12787 3.28204 8.98585 3.77134 9.45164 4.8344C9.51679 4.98326 9.54652 5.14816 9.57667 5.30825C9.62812 5.58109 9.59144 5.6162 9.29687 5.616L9.29708 5.6158Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke2_27418_115094",
    d: "M8.19059 5.61365C7.92976 5.61645 7.93883 5.61425 7.87389 5.37672C7.76635 4.98371 7.48022 4.7528 7.08296 4.63304C7.04564 4.6218 7.00621 4.61639 6.96783 4.60856C6.73779 4.56182 6.70342 4.51849 6.72935 4.30563C6.74517 4.17583 6.81285 4.10421 6.95961 4.101C7.52133 4.08857 7.93419 4.35418 8.24014 4.76384C8.37762 4.9478 8.45944 5.16728 8.51742 5.40501C8.54863 5.5336 8.48453 5.60422 8.33862 5.61304C8.28949 5.61605 8.23993 5.61344 8.19059 5.61344V5.61365Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke4_27418_115094",
    d: "M6.55586 4.89512C7.21458 5.1186 7.56397 5.46246 7.59096 6.12469C7.61014 6.59554 7.60276 7.07099 7.55363 7.53943C7.51062 7.94989 7.23651 8.25402 6.83693 8.40067C6.52086 8.51683 6.17821 8.60009 5.84126 8.62597C5.19077 8.67552 4.53395 8.69538 3.89125 8.54251C3.29896 8.40148 2.86248 8.09092 2.76591 7.48246C2.68072 6.94521 2.6803 6.40274 2.77645 5.8653C2.85447 5.42835 3.13006 5.12061 3.55683 4.97075C3.85878 4.86483 4.4884 4.69169 5.02883 4.69189C5.68333 4.6921 6.14131 4.75449 6.55586 4.89512ZM5.99772 7.90375C6.33825 7.83173 6.48606 7.64435 6.49302 7.31133C6.50146 6.90609 6.50146 6.50024 6.49302 6.095C6.48606 5.75375 6.35491 5.58564 6.0051 5.49877C5.79529 5.44661 5.57242 5.41391 5.35671 5.41872C5.00331 5.42655 4.64444 5.443 4.29989 5.51041C3.97876 5.5732 3.84508 5.78043 3.84128 6.0944C3.83664 6.48881 3.83664 6.88322 3.84107 7.27763C3.84508 7.63874 3.99099 7.83012 4.35788 7.90676C4.62208 7.96193 5.72803 7.96092 5.99793 7.90375H5.99772Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTokenRed);
export default __webpack_public_path__ + "static/media/ic-token-red.26a0e67942565ef5dd448d1440e9dc92.svg";
export { ForwardRef as ReactComponent };